import { ControlValueAccessor } from '@angular/forms';

export abstract class BaseControlValueAccessor<T> implements ControlValueAccessor {
  public value: T;

  public onChange: (value: T) => void = () => {};
  public onTouch: () => void = () => {};

  public writeValue(value: T): void {
    this.value = value;
    this.onChange(value);
  }

  public registerOnChange(fn: (value: T) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouch = fn;
  }

  public updateValue(value: T): void {
    this.writeValue(value);
    this.onTouch();
  }

  public resetValue(defaultValue: T): void {
    this.value = defaultValue;
    this.onChange(this.value);
    this.onTouch();
  }
}
